<template>
  <div class="">
    <my-header-view
      :title="'Menu establecimiento'"
      icon="mdi-storefront-outline"
      text="Selecciona una de las opciones disponibles"
    />
    <v-row class="mt-14">
      <v-col
        cols="12"
        sm="4"
        md="6"
        lg="6"
        v-for="menu in menus"
        :key="menu.name"
      >
        <my-menu-card
          :title="menu.name"
          :description="menu.description"
          :url="menu.url"
          :img-url="menu.imgUrl ? menu.imgUrl : null"
          :icon="menu.icon ? menu.icon : null"
          :backgroundColor="menu.backgroundColor"
          :big-icon="true"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import myMenuCard from "../ui/myMenuCard";
import myHeaderView from "../ui/myHeaderView";

export default {
  components: {
    myMenuCard,
    myHeaderView,
  },
  data: function () {
    return {
      menus: [],
      openEliminarActividades: false,
    };
  },
  methods: {
    createMenus() {
      this.menus = [
        {
          name: "Nuevo establecimiento",
          icon: "img/catalogos.png",
          url: "CrearEstablecimiento",
          imgUrl: "/img/menus/establecimiento/crearEstablecimiento.jpg",
          backgroundColor: "secondary",
        },
        {
          name: "Agregar establecimiento ",
          icon: "img/catalogos.png",
          imgUrl: "/img/menus/establecimiento/agregarEstablecimiento.jpg",
          url: "AgregarEstablecimiento",
          backgroundColor: "secondary",
        },
      ];
    },
  },
  computed: {},
  mounted() {
    this.createMenus();
  },
};
</script>
